import { useAppSelector } from '../../../../../../../../store/hooks';
import { getActiveMandantIdSelector } from '../../../../../../../shared/store/selectors/get-active-mandant-id/get-active-mandant-id.selector';
import { getIsAppLoadingSelector } from '../../../../../../../shared/store/selectors/get-is-app-loading/get-is-app-loading.selector';
import { getCampaignsSelector } from '../../../../../../selectors/get-campaigns-selector/get-campaigns.selector';
import { CampaignsOverviewTableConfigModel } from './models/campaigns-overview-table-config.model';

export const useGetCampaignsTableSelectors =
  (): CampaignsOverviewTableConfigModel => {
    const campaigns = useAppSelector(getCampaignsSelector);
    const isLoading = useAppSelector(getIsAppLoadingSelector);
    const activeMandantId = useAppSelector(getActiveMandantIdSelector);
    const campaignFilters = useAppSelector(
      state => state.campaignsFeature.campaigns.filters
    );
    const campaignHeaderFilters = campaignFilters.header;
    const count = campaignFilters.pagination.totalCount;
    const rowsPerPage = campaignFilters.pagination.size;
    const page = campaignFilters.pagination.pageNumber;

    return {
      campaigns,
      isLoading,
      activeMandantId,
      campaignFilters,
      campaignHeaderFilters,
      count,
      page,
      rowsPerPage,
    };
  };
